export enum HandleType {
	FULL = 0,
	NONE = 1,
	SMALL = 2,
	SELF = 3,
}
